import React, { FC, Fragment } from 'react'
import { Form, Input, Row, Col, Select} from 'antd';
import { EnumUtils } from "../../../../../../utils";
import { StatusEnum } from "../../../../../../utils/enums";
import { rules } from '../../../../../../components/Validation/Form.validate';
import { useTranslation } from "react-i18next";

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 24 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
    },
};

const DepartmentHeadRecommendationAddOrEditForm: FC<any> = props => {
    const { Option } = Select;
    const { TextArea } = Input;
    const { t } = useTranslation();
    const { formRef, initialValues, handleChange, handleSubmit, handleSubmitFailed } = props;
    return (
        <Fragment>
            <div className="form-page-content form-page-content-researcherConsent">
                <Form
                    {...formItemLayout}
                    form={formRef}
                    name="researcherConsentForm"
                    scrollToFirstError={true}
                    initialValues={initialValues}
                    onValuesChange={handleChange}
                    onFinish={handleSubmit}
                    onFinishFailed={handleSubmitFailed}
                >
                    <Row>
                        <Col xs={24} md={24}>

                            <Form.Item
                                label={t("Remarks")}
                                name="remark"
                            >
                                <TextArea allowClear />
                            </Form.Item>

                            <Form.Item
                                label="Status"
                                name="action_status"
                            >
                                <Select placeholder={"--" + t('Select') + "--"} >
                                    <Option key={`status-0`} value={0}>{t('Pending')}</Option>
                                    <Option key={`status-1`} value={1}>{t('Accept')}</Option>
                                    <Option key={`status-2`} value={2}>{t('Reject')}</Option>
                                </Select>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </div>
        </Fragment >
    );
}
export default React.memo(DepartmentHeadRecommendationAddOrEditForm);
